import { useEffect, useState } from "react";
import axios from "axios"

function GitRepos() {
  const [repos,  setRepos] = useState<any[] | null>()
  const END_REPOS_GITHUB_ENDPOINT = "https://gh-pinned-repos.egoist.dev/?username=sammyngy"
  useEffect(() => {
    axios.get(END_REPOS_GITHUB_ENDPOINT).then((response: any) => {
      setRepos(response.data)
    })
  },[]);
    return (
      <div  className="my-5">
        <h2 className="text-2xl font-bold sm:text-3xl mb-6">
          GitHub repos
        </h2>
        <ul className="grid md:grid-cols-2 gap-4 sm:grid-cols-2">
          {
            repos && repos.map(repo => (
              <li className="drop-shadow-xl bg-zinc-800 rounded-lg p-5">
                <div className="flex items-center space-x-2 text-lg mb-1">
                  <a href={repo.link} target="_blank" rel="noreferrer"><i className="devicon-github-plain"/></a><span>{repo.repo}</span> 
                </div>
                <p className="opacity-60">
                  {repo.description}
                </p>
                {
                  repo.language && repo.languageColor && (
                    <div className="bg-zinc-500 mt-2 rounded-lg p-1 flex items-center w-32">
                      <div style={{backgroundColor: repo.languageColor}} className="p-1 mx-2 rounded-full"></div> 
                      <p className="text-sm">{repo.language}</p>
                    </div>
                  )
                }
              </li>
            ))
          }
        </ul>
      </div>
    );
  }
  
  export default GitRepos;
  